export default __webpack_public_path__ + "static/media/slide2.72566ef1.png";